export const APP_NAME = 'Casino';
